import * as CookieConsent from 'vanilla-cookieconsent'

import { notifyAgtmConsentUpdate } from '@/lib/tracking/agtm'

export function syncTrackingConsent(): void {
  if (typeof window === 'undefined') return
  if (!CookieConsent.validConsent()) return

  notifyAgtmConsentUpdate()
}
